<template>
  <section>
    <grid-component
      isResizable
      isReorderable
      :gridId="gridId"
      :fields="fields"
      :itemData="inventorySplitList"
     />

  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import { GRID_ID } from '@/shared/constants';
import fields from './fields';

export default {
  components: {
    GridComponent
  },
  props: {
    inventoryId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      fields,
      gridId: GRID_ID.INVENTORY_SPLIT_GRID
    }
  },
  computed: {
    ...mapGetters('inventory', ['inventorySplitList']),
  },
  methods: {
    ...mapActions('inventory', ['getInventorySplits'])
  },
  watch: {
    async inventoryId() {
      await this.getInventorySplits(this.inventoryId);
    }
  }
}
</script>